import { useMutation } from '@tanstack/react-query';
import { timeOffService } from '../api/time-off.service';

/**
 * Imports historical requests from a CSV/Excel file. Owner/Admin only. The
 * backend parses the file and always resolves with `{created, errors}` — a
 * failing row never rejects the mutation, so the caller renders both arrays
 * from the success payload. No cached query invalidation — this module
 * exposes no admin-facing read for historical requests.
 */
export function useBulkImportHistoricalTimeOffRequests() {
  return useMutation({
    mutationFn: (file: File) => timeOffService.bulkImportHistoricalRequests(file),
  });
}
